import { mapGetters, mapActions } from "vuex";
import Utils from "@/mixins/Utils";
import pointage from "@/mixins/pointage";
import employeeService from "@/services/employee";
import agencyService from "@/services/agency";
import { analytics } from "@/services/firebase";
import { EVENT_NAME } from "@/constants/variables";

export default {
  data: () => ({
    errorMasterReclamation: false,
    agency: {},
    showErrors: false,
    isSent: false,
    hasError: false
  }),
  mixins: [Utils, pointage],
  async created() {
    this.$set(this.support, 'agencyInformed', null);
    await this.checkIfAllowed();
    this.getMyAgency();
    this.init();
  },
  computed: {
    ...mapGetters('hrSupport', {
      reasons: 'reasons',
      appVersion: 'appVersion'
    }),
    isFormValid() {
      return !!(
        this.support.agencyInformed !== null &&
        this.support.reason &&
        this.support.title &&
        this.support.message
      );
    },
  },
  methods: {
    ...mapActions('hrSupport', {
      init: 'init',
      send: 'send'
    }),
    trackClick(eventName) {
      analytics.logEvent(eventName, {
        platform: 'web'
      });
    },
    resetData() {
      this.support = {
        reason: undefined,
        title: undefined,
        message: undefined,
        agencyInformed: null
      };
    },
    handleSubmit() {
      this.trackClick(EVENT_NAME.CLIC_SERVICE_RH_MEDIATION_ENVOYER);
      if (!this.isFormValid) {
        this.showErrors = true;
        return;
      }
      this.showErrors = false;
      if (this.$refs.formCard && this.$refs.formCard.$el) {
        this.$refs.formCard.$el.style.height = this.$refs.formCard.$el.offsetHeight + 'px';
      }
      this.submitReclamation();
    },
    handleRetry() {
      this.hasError = false;
      if (this.$refs.formCard && this.$refs.formCard.$el) {
        this.$refs.formCard.$el.style.height = '';
      }
    },
    async submitReclamation() {
      this.isSubmitting = true;
      const result = await this.$validator.validateAll();
      if (result) {
        try {
          await this.send({
            firstName: this.profile.firstName,
            name: this.profile.name,
            email: this.profile.email,
            reason: this.support.reason ? this.support.reason : '',
            title: this.support.title,
            messages: this.support.message,
            agencyInformed: this.support.agencyInformed,
            versionApp: this.appVersion,
            agencyName: this.agency.name || '',
            device: this.device,
            browser: this.browser,
            pkAdv: this.profile.pkAdv,
            pointings: this.pointings
          });
          this.isSent = true;
          this.trackClick(EVENT_NAME.RECLAMATION_SENT);
        } catch (err) {
          this.hasError = true;
          this.trackClick(EVENT_NAME.RECLAMATION_KO);
        } finally {
          this.isSubmitting = false;
        }
      }
    },
    async getMyAgency() {
      const vue = this;
      await agencyService
        .getAgence()
        .then((res) => {
          vue.agency = res.data.agency || {};
        })
        .catch((err) => {
          // Handler error
        });
    },
    async checkIfAllowed() {
      const vue = this;
      await employeeService
        .checkReclaimation()
        .then((res) => {
          if (res.success) {
            vue.errorMasterReclamation = false;
          }
        })
        .catch((err) => {
          vue.errorMasterReclamation = true;
        });
    }
  },
};
